// 赠课卡
const StuGiftCard = {
    ajaxGetStuGiftCard: '//ocenter.xueersi.com/StuGiftCard/ajaxGetStuGiftCard',
    getAllCourseInfos: '//ocenter.xueersi.com/StuGiftCard/getAllCourseInfos',
    getCourseInfo: '//ocenter.xueersi.com/StuGiftCard/getCourseInfo',
    getGiveawayInfo: '//ocenter.xueersi.com/StuGiftCard/getGiveawayInfo',
    ajaxGetStuAdds: '//ocenter.xueersi.com/StuGiftCard/ajaxGetStuAdds',
    saveStuAdds: '//ocenter.xueersi.com/StuGiftCard/saveStuAdds',
    delStuAddress: '//ocenter.xueersi.com/StuGiftCard/delStuAddress',
    setDefaultAdds: '//ocenter.xueersi.com/StuGiftCard/setDefaultAdds',
    exchangeCourse: '//ocenter.xueersi.com/StuGiftCard/exchangeCourse',
    ajaxActiveGcard: '//ocenter.xueersi.com/ActiveGift/ajaxActiveGcard',
    getShowCouInfo: '//ocenter.xueersi.com/StuGiftCard/getShowCouInfo',
    // 兑换记录
    getExchangeList: '//ocenter.xueersi.com/StuGiftCard/getExchangeList'
}
// 领券中心
const Vencher = {
    ajaxGetCouponList: '//ocenter.xueersi.com/Coupon/ajaxGetCouponList',
    ajaxGetCouponRange: '//ocenter.xueersi.com/Coupon/ajaxGetCouponRange',
    stuReceiveCoupon: '//ocenter.xueersi.com/StuCoupon/stuReceiveCoupon'
}
// 用户中心
const Profile = {
    info: '//account.xueersi.com/Profile/info',
    checkVCode: '//account.xueersi.com/Profile/checkVCode',
    sendSMSCode: '//account.xueersi.com/Profile/sendSMSCode',
    resetPwd: '//account.xueersi.com/Profile/resetPwd',
    bindPhone: '//account.xueersi.com/Profile/bindPhone',
    bindInfos: '//account.xueersi.com/Profile/bindInfos',
    bindPlat: '//account.xueersi.com/Profile/bindPlat',
    unbindPlat: '//account.xueersi.com/Profile/unbindPlat',
    addrInfos: '//account.xueersi.com/Profile/addrInfos',
    addrMod: '//account.xueersi.com/Profile/addrMod',
    addrRm: '//account.xueersi.com/Profile/addrRm'
}
// 订单相关
const Order = {
    ajaxGetOrderList: '//ocenter.xueersi.comyOrderData/ajaxGetOrderList',
    getNormalOrderDetail: '//ocenter.xueersi.comyOrderData/getNormalOrderDetail?',
    getECardOrderDetail: '//ocenter.xueersi.comyOrderData/getECardOrderDetail?',
    ajaxGetPackageAdd: '//ocenter.xueersi.comyInfoData/ajaxGetPackageAdd?',
    ajaxStuAdds: '//ocenter.xueersi.comyInfoData/ajaxStuAdds',
    saveSendInfosAddsById: '//ocenter.xueersi.comyInfoData/saveSendInfosAddsById',
    saveNewSendInfosAdds: '//ocenter.xueersi.comyInfoData/saveNewSendInfosAdds',
    ajaxGetExpress: '//ocenter.xueersi.comyInfoData/ajaxGetExpress?',
    ajaxGetFinances: '//ocenter.xueersi.comyInfoData/ajaxGetFinances',
    getReturnCourseInfo: '//ocenter.xueersi.comyOrderData/getReturnCourseInfo',
    ajaxReturnCourse: '//ocenter.xueersi.comyOrderData/ajaxReturnCourse'
}

export default {StuGiftCard, Order, Profile}



// WEBPACK FOOTER //
// ./module/forgetPassword/src/service/service.js